import React, { useState, useEffect } from 'react';
import { Text } from '@chakra-ui/react';

import { Input, UploadActions, UploadComplete as UploadCompleteSection, Modal } from 'shared-components';

interface IProps {
  closeModal: () => void;
  title: string;
  openUploadModal: (
    docKey: string,
    docType: string,
    sponsorType: string,
    sponsorKey: string | null,
    modalTitle: string,
    fileNames: string[],
    metadata: any
  ) => void;
  docType: string;
  sponsorType: string;
  isComplete: boolean;
  docKey: string;
  fileNames: string[];
  flightNumber: string | undefined;
}

export const NewTravelTicketModal = (props: IProps) => {
  const {
    closeModal,
    openUploadModal: initOpenUploadModal,
    fileNames,
    docKey,
    isComplete: isDocumentApproved,
    sponsorType,
    docType,
    title,
    flightNumber: initFlightNumber
  } = props;

  const openUploadModal = (metadata: any) => {
    initOpenUploadModal(docKey, docType, sponsorType, null, 'Travel ticket or Booking', fileNames, metadata);
  };
  const [flightNumber, setFlightNumber] = useState<string>(initFlightNumber ?? '');
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    if (flightNumber.length) {
      setIsComplete(true);
    }
  }, [flightNumber, setIsComplete]);

  const returnToSection = () => {
    closeModal();
  };

  const uploadDocument = () => {
    openUploadModal({
      flightNumber: flightNumber
    });
  };

  return (
    <Modal id={'newStudentVisaVignetteModal'} show={true} title={title} onClose={closeModal} hideFooter>
      {isDocumentApproved ? (
        <UploadCompleteSection fileNames={fileNames} onUpload={uploadDocument} onContinue={returnToSection} />
      ) : (
        <>
          <Text>
            We require a photo or scan of your plane, train, bus or other ticket/travel booking showing the date of enty
            to the UK.
          </Text>

          <Text>
            If your travel date has changed, please update your travel status in the enrolment status section.
          </Text>

          <Input
            label="What is the flight number?"
            subText="If your mode of transport is not a plane, enter the train/ship/other number"
            value={flightNumber}
            onChange={(evt: React.FormEvent<HTMLInputElement>) => {
              setFlightNumber(evt.currentTarget.value);
            }}
          />

          <UploadActions complete={isComplete} disabled={!isComplete} onContinue={uploadDocument} />
        </>
      )}
    </Modal>
  );
};
